import {
    LIST_VIEWERS_START,
LIST_VIEWERS_SUCCESS,
LIST_VIEWERS_FAILED
  } from "../../../constants";
  import { ApiBase } from "../../../../utils/apiBase";
  import { withType } from "../../../../utils/actionOperations";
  import { LISTVIEWERUSERS } from "../../../../../config/constants";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
  
export const listViewers = (payload, callback) => {
    const apiBaseInstance = new ApiBase();
    return (dispatch) => {
      dispatch(withType(LIST_VIEWERS_START, {}));
      apiBaseInstance.instance
        .post(LISTVIEWERUSERS, { ...payload, ...getProjectIdAndOrgId(payload) })
        .then((response) => {
          dispatch(
            withType(LIST_VIEWERS_SUCCESS, {
              data: response.data,
              message: response.message,
            })
          );
          callback && callback();
        })
        .catch((err) => {
          dispatch(
            withType(LIST_VIEWERS_FAILED
                , {
              error: err,
            })
          );
        });
    };
  };
  